import { render, staticRenderFns } from "./BundlePage.vue?vue&type=template&id=7e2f8d70&scoped=true&"
import script from "./BundlePage.vue?vue&type=script&lang=js&"
export * from "./BundlePage.vue?vue&type=script&lang=js&"
import style0 from "./BundlePage.vue?vue&type=style&index=0&id=7e2f8d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f8d70",
  null
  
)

export default component.exports